import React, { useRef } from 'react';
import GlobalStyle from 'global.styles';

import { Toasts } from 'components/ui';
import { useTextFieldSearchTrucker } from 'hooks/openSearchTrucker/useTextField';
import OpenSearchContent from '../Content';
import * as Styled from './styled';

export const ContentWrapper = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const {
    propsTextField: { states },
  } = useTextFieldSearchTrucker();

  return (
    <Styled.ContentWrapper $isOpen={states.isTextFieldFocus} ref={wrapperRef}>
      <GlobalStyle />
      <OpenSearchContent outsideRefs={[wrapperRef]} />
      <Toasts portalName="portal-search-trucker" />
      <div id="portal-search-trucker" />
    </Styled.ContentWrapper>
  );
};
